import React from "react";

export default function Default() {
  return <> YTS-REPORTS </>;
}
